module.exports = __webpack_public_path__ + "assets/img/hj-one.03b4da24.png";